/**
 * Estilo padrão do avatar com abreviação/iniciais (ex.: HRQ, ADM),
 * igual ao círculo do perfil no topo da aplicação.
 * @param {object} theme - Theme do Material-UI
 * @param {number} nTamanho - Diâmetro do avatar em px
 * @param {{ cCorFundo?: string, cCorTexto?: string }} [oOpcoes]
 * @returns {object}
 */
const obterEstiloAvatarAbreviacao = (theme, nTamanho = 48, oOpcoes = {}) => ({
  backgroundColor: oOpcoes.cCorFundo || theme.palette.background200,
  color: oOpcoes.cCorTexto || theme.palette.primary200,
  fontFeatureSettings: "'liga' off, 'clig' off",
  fontFamily: "Roboto",
  fontSize: Math.max(10, Math.round(nTamanho * 0.33)),
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "125%",
  letterSpacing: "-0.04px",
})

export default obterEstiloAvatarAbreviacao
